import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function Identification() {
  const points = ['No tenés tiempo para ir al gimnasio', 'Empezás rutinas pero las abandonás rápido', 'Querés entrenar pero no sabés por dónde empezar', 'Querés mejorar tu cuerpo desde casa', 'Buscás algo simple que realmente puedas mantener'];
  return <section className="py-20 bg-white" data-id="element-124">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-125">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-126">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-127">
            Este programa es para vos si…
          </h2>
          <div className="w-24 h-1.5 bg-rose-500 mx-auto rounded-full" data-id="element-128" />
        </motion.div>

        <div className="bg-gray-50 rounded-3xl p-8 md:p-12 border border-gray-100 shadow-sm" data-id="element-129">
          <ul className="space-y-6" data-id="element-130">
            {points.map((point, index) => <motion.li key={index} className="flex items-start gap-4" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} data-id="element-131">
                <div className="mt-1 bg-white rounded-full p-1 shadow-sm" data-id="element-132">
                  <XCircle className="w-6 h-6 text-rose-500" data-id="element-133" />
                </div>
                <span className="text-lg md:text-xl text-gray-700 font-medium leading-relaxed" data-id="element-134">
                  {point}
                </span>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}